/**
 * ClientInputList — renders a list of client input lines
 * (calculator / classifier-with-modifier). Moved out of
 * ServiceManagementPage.tsx (KAN-157 god-component split).
 */
import type { InputLine } from '@/utils/serviceFormula';

export function ClientInputList({ lines }: { lines: InputLine[] }): JSX.Element {
  return (
    <ul className="text-sm text-gray-700 space-y-0.5">
      {lines.map((line, idx) => (
        <li key={line.key || idx}>{line.text}</li>
      ))}
    </ul>
  );
}
